<template>
    <div class="companies-view">
        <company-return-menu v-bind:ReturnMenuSettings="ReturnMenuSettings"/>
        <section class="companies-landing --claim-central">
            <div class="dark-filter"></div>
            <div class="comp-logo"><router-link to="/home"><img width="150px" src="../assets/imgs/icons/global-choices-logo-white.png"> </router-link></div>
            <div class="intro-hd-container">
                <!-- <img src="../assets/imgs/icons/tic-graph.png"> -->
                <img src="../assets/imgs/icons/cc-africa-stacked.png">

                <p class="content-text --fl --prim">
                    We make insurance claims easier for insurers and customers by providing claims management services, claims technology and real-time data insights.
                </p>
                <a href="https://claimcentral.co.za/" target="_blank" rel="noopener noreferrer" class="btn comps-btn">GAIN CLAIM INSIGHT</a>
            </div>

            <div class="social-icons-mobile">
                <ul class="social-items">
                    <li><a href="https://www.facebook.com/GlobalChoicesZA/" class="facebook" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://twitter.com/GlobalChoicesZA" class="twitter" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.linkedin.com/company/global-choices-lifestyle/?originalSubdomain=za" class="linkedin" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.instagram.com/globalchoicesza/" class="instagram" target="_blank" rel="noopener noreferrer"></a></li>
                    <li><a href="https://www.youtube.com/channel/UCbCW_LVHs3zhXqtY6yRETBQ" class="youtube" target="_blank" rel="noopener noreferrer"></a></li>
                </ul>
            </div>
            <SocialIconsMobile v-bind="SocialIconsMobileSettings" />
        </section>
    </div>
</template>

<script>
import CompanyReturnMenu from '@/components/ui/CompanyReturnMenu'
import SocialIconsMobile from '@/components/ui/SocialIconsMobile'

export default {
    components: { CompanyReturnMenu,SocialIconsMobile},
    data(){
        return {
            ReturnMenuSettings:{
                colorTheme:false
            },
            SocialIconsMobileSettings:{
                DarkIconsTrue:false
            }
        }
    } 
}
</script>

<style>

</style>
